import React from 'react';
import './SunDesigns.css';

const Emblem = () => (
  <svg className="d5-emblem" viewBox="0 0 100 100" fill="none" aria-hidden="true">
    <g className="core" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="50" cy="50" r="17" fill="none" />
      <g>
        <path d="M50 8v12M50 80v12M8 50h12M80 50h12" />
        <path d="M21 21l8 8M71 71l8 8M79 21l-8 8M29 71l-8 8" />
        <path d="M50 14v6M50 80v6" opacity=".5" />
      </g>
    </g>
    <circle cx="50" cy="50" r="9" fill="currentColor" />
  </svg>
);

// 05 · Rasathane — Vintage · takvim yaprağı
const D5Rasathane = ({ vm }) => (
  <div className="gsk">
    <div className="stage">
      <div className="d5">
        <Emblem />
        <div className="d5-place">Rasathane Kaydı · {vm.location}</div>
        <h3 className="d5-title">Güneşin Doğuşu &amp; Batışı</h3>
        <div className="d5-date">{vm.dateLong}</div>
        <div className="d5-cols">
          <div className="d5-col">
            <div className="lab">Doğuş</div>
            <div className="big">{vm.sunriseDst}</div>
            {vm.isDst && <div className="sm">standart <span>{vm.sunriseNormal}</span></div>}
          </div>
          <div className="d5-div"></div>
          <div className="d5-col">
            <div className="lab">Batış</div>
            <div className="big">{vm.sunsetDst}</div>
            {vm.isDst && <div className="sm">standart <span>{vm.sunsetNormal}</span></div>}
          </div>
        </div>
        <p className="d5-note"><b>Not.</b> {vm.dstNote}</p>
      </div>
    </div>
  </div>
);

export default D5Rasathane;
